import { render, staticRenderFns } from "./InputWrapper2.vue?vue&type=template&id=76a7e89e&scoped=true"
import script from "./InputWrapper2.vue?vue&type=script&lang=js"
export * from "./InputWrapper2.vue?vue&type=script&lang=js"
import style0 from "./InputWrapper2.vue?vue&type=style&index=0&id=76a7e89e&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76a7e89e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('76a7e89e')) {
      api.createRecord('76a7e89e', component.options)
    } else {
      api.reload('76a7e89e', component.options)
    }
    module.hot.accept("./InputWrapper2.vue?vue&type=template&id=76a7e89e&scoped=true", function () {
      api.rerender('76a7e89e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/UI/InputWrapper2.vue"
export default component.exports